<template>
  <v-sheet class="px-3 py-3" :color="$vuetify.theme.dark ? '#1A2A3E' : '#E8F1F8'">
    <apexChart width="100%" height="338px" type="bar" :options="options" :series="processedSeries"
      class="liveTradeChart">
    </apexChart>
  </v-sheet>
</template>

<script>
export default {
  props: {
    trades: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      options: {
        chart: {
          id: "vuechart-example",
          type: "bar",
          height: "338px",
          theme: "dark",
          stacked: true,
        },
        xaxis: {
          categories: ["Sat", "Sun", "Mon", "Tue", "Wed"],
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          labels: {
            style: {
              colors: ["#708AA7"],
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: ["#708AA7"],
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 2
          },
        },
        colors: ["#039de9", "#FF567F"],
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Buy", "Sale"],
          labels: {
            colors: ["#647E98"],
            useSeriesColors: false,
          },
          markers: {
            fillColors: ["#039de9", "#FF567F"],
            radius: 12,
          },
        },
      }
    };
  },
  computed: {
    processedSeries() {
      const dailyTrades = {
        'Sat': { Buy: 0, Sale: 0 },
        'Sun': { Buy: 0, Sale: 0 },
        'Mon': { Buy: 0, Sale: 0 },
        'Tue': { Buy: 0, Sale: 0 },
        'Wed': { Buy: 0, Sale: 0 }
      };

      this.trades.forEach(trade => {
        const date = new Date(trade.Time);
        const day = date.toLocaleDateString('en-US', { weekday: 'short' });
        const actionType = trade.Action === 0 ? 'Buy' : 'Sale';

        if (dailyTrades[day]) {
          dailyTrades[day][actionType] += 1;
        }
      });

      return [
        {
          name: "Buy",
          data: Object.values(dailyTrades).map(day => day.Buy)
        },
        {
          name: "Sale",
          data: Object.values(dailyTrades).map(day => day.Sale)
        }
      ];
    }
  }
};
</script>

<style></style>